import type { InjectionKey } from "vue";

export const filterPanelSelectAllKey: InjectionKey<boolean> = Symbol("filterPanelSelectAll");
